import { render, staticRenderFns } from "./alipayInfo.vue?vue&type=template&id=20365a76&scoped=true&"
import script from "./alipayInfo.vue?vue&type=script&lang=js&"
export * from "./alipayInfo.vue?vue&type=script&lang=js&"
import style0 from "./alipayInfo.vue?vue&type=style&index=0&id=20365a76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20365a76",
  null
  
)

export default component.exports